export function getEditableTextBg(_a) {
    var isHighlighted = _a.isHighlighted, isCollapsed = _a.isCollapsed;
    if (isHighlighted) {
        return 'snowDark';
    }
    if (isCollapsed) {
        return 'transparent';
    }
    return 'white';
}
